import React from "react";
import { Container } from "react-bootstrap";
import Component_3 from "../tabs_common_components/component_3/Component_3";
import Component_1 from "../tabs_common_components/component_1/Component_1";
import Component_2 from "../tabs_common_components/component_2/Component_2";
import Component_5 from "../tabs_common_components/component_5/Component_5";
import "./Kids_athletics.css";

const Kids_athletics = () => {
  const focusData = [
    {
      id: 1,
      icon: "/assets/images/sports-program/component-3/strength.png",
      title: "Strength",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 2,
      icon: "/assets/images/sports-program/component-3/endurance.png",
      title: "Endurance",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 3,
      icon: "/assets/images/sports-program/component-3/speed-agility.png",
      title: "Speed",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 4,
      icon: "/assets/images/sports-program/component-3/flexibility.png",
      title: "Flexibility",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 5,
      icon: "/assets/images/sports-program/component-3/core-stability.png",
      title: "Core Stability",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 6,
      icon: "/assets/images/sports-program/component-3/fat-loss.png",
      title: "Fat Loss",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 7,
      icon: "/assets/images/sports-program/component-3/body-toning.png",
      title: "Weight Gain",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 8,
      icon: "/assets/images/sports-program/component-3/co-ordination.png",
      title: "Co-ordination",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
  ];
  return (
    <section className="kids-fitness-section">
      <Container>
        <Component_1
          topDescn={
            "Athletics training involves a systematic process to improve an athlete's performance, focusing on developing core components like strength, endurance, speed, flexibility, and coordination.Our training plans should be structured based on scientific principles, such as continuity, progression, and specificity, to improve performance over time, and must include recovery and proper nutrition.."
          }
          title={"Key Phases of Marathon Training"}
          features={[
            {
              label: "Base Building (8–12 Weeks)::",
              value:
                "Focus on consistency and running volume with easy, conversational-paced runs to develop cardiovascular fitness and endurance.",
            },
            {
              label: "Strength & Speed (4–6 Weeks):",
              value:
                "Incorporate challenging sessions like interval training and tempo runs to improve running efficiency, strength, and race pace.",
            },
            {
              label: "Peak Phase (2–4 Weeks):",
              value:
                "Push endurance limits with your longest runs — peaking around 30–32 km (20 miles) — three to four weeks before race day.",
            },
            {
              label: "Tapering (2–3 Weeks):",
              value:
                "Gradually reduce mileage to rest, recover, and store energy for your best performance on race day.",
            },
          ]}
          imgSrc="/assets/images/sports-program/component-1/kids-athletics.jpeg"
        />
        <Component_2
          title={"Weekly Training Components"}
          imgSrc="./assets/images/sports-program/component-2/run.png"
          features={[
            {
              label: "Runs:   ",
              value: "3–4 weekly runs focusing on endurance and form.",
              imgSrc: "./assets/images/sports-program/component-2/run.png",
            },
            {
              label: "Long Runs:  ",
              value:
                "One weekly long run that increases in distance each week. Run at a steady, comfortable pace.",
              imgSrc: "./assets/images/sports-program/component-2/long-run.png",
            },
            {
              label: "Easy Runs:",
              value:
                "Short, low-intensity runs for recovery and aerobic conditioning.",
              imgSrc: "./assets/images/sports-program/component-2/easy-run.png",
            },
            {
              label: "Speed Work:",
              value:
                "Includes tempo runs, intervals, and hill sprints to boost speed and stamina.",
              imgSrc:
                "./assets/images/sports-program/component-2/speed-work.png",
            },
            {
              label: "Cross-Training: ",
              value:
                " 1–2 low-impact sessions like swimming or cycling to build strength and reduce injury risk.",
              imgSrc:
                "./assets/images/sports-program/component-2/cross-training.png",
            },
            {
              label: "Strength Training:",
              value:
                " Focus on legs and core with exercises like squats, lunges, and deadlifts for better running power.",
              imgSrc: "./assets/images/sports-program/component-2/strength.png",
            },
            {
              label: "Rest:",
              value:
                "Rest is essential for muscle recovery and injury prevention — never skip it.",
              imgSrc: "./assets/images/sports-program/component-2/rest.png",
            },
          ]}
        />

        <Component_2
          title={" Foundational and conditioning components"}
          imgSrc="./assets/images/sports-program/component-2/run.png"
          features={[
            {
              label: " Strength and power    ",
              value: "Training the muscles needed for athletic movements.",
              imgSrc: "./assets/images/sports-program/component-2/strength.png",
            },
            {
              label: " Speed and agility   ",
              value:
                "Developing the ability to move quickly and change direction.",
              imgSrc: "./assets/images/sports-program/component-2/rest.png",
            },
            {
              label: " Endurance : ",
              value:
                "Building aerobic (long-duration) and anaerobic (high-intensity) capacity.",
              imgSrc:
                "./assets/images/sports-program/component-2/speed-work.png",
            },
            {
              label: " Flexibility and mobility",
              value:
                " Improving range of motion to enhance performance and prevent injury.",
              imgSrc:
                "./assets/images/sports-program/component-2/cross-training.png",
            },
            {
              label: " Core conditioning:  ",
              value: "Strengthening the trunk for overall stability.",
              imgSrc:
                "./assets/images/sports-program/component-2/speed-work.png",
            },
          ]}
        />

        <Component_5
          title={"Training Includes"}
          features={[
            "Sprint training (short & long distance)",
            "Endurance running",
            "Strength & conditioning workouts",
            "Agility and coordination drills",
            "Flexibility & mobility exercises",
            "Warm-up and cool-down routines ",
            "Technique improvement sessions",
          ]}
        />
        <div className="content">
          <h2 className="div-title">About Athletics Training </h2>
          <p className="text">
            Our Athletics Training Program is designed to develop speed,
            strength, endurance, and overall performance.
          </p>

          <h2 className="div-title">Our Mission </h2>
          <p className="text">
            To create strong, confident, and disciplined athletes by providing
            professional training in a positive and motivating environment.
          </p>
        </div>

        <Component_3 focusData={focusData} showTitle={false} />
      </Container>
    </section>
  );
};

export default Kids_athletics;
